const schema = {
    'firstName': {
      presence: { allowEmpty: false, message: 'is required', admin: 'required', label: 'First Name*' },
      length: {
          minimum: 1,
        maximum: 32
      },

    },
    'lastName': {
      presence: { allowEmpty: false, message: 'is required', admin: 'required', label: 'Last Name*' },
      length: {
          minimum: 2,
        maximum: 32
      },

    },
    email: {
      presence: { allowEmpty: false, message: 'is required', admin: 'required', label: 'Email*' },
      email: true,
      length: {
        maximum: 128
      },
    },
    emailAgain: {
      presence: { allowEmpty: false, message: 'is required', admin: 'required', label: 'Repeat Email*' },
      email: true,
      length: {
        maximum: 128  ,         
        message: "must be at least 8 characters",
      },

    },
    'address1': {
      presence: { allowEmpty: false, message: 'is required', admin: 'optional', label: 'Address 1' },
      email: false,
      length: {
          minimum: 1,
        maximum: 50,
        message: "must be at least 2 characters",
      },

    },
    'address2': {
      presence: { allowEmpty: true, message: 'not required', admin: 'optional', label: 'Address 2' },
      email: false,
      length: {
          minimum: 1,
        maximum: 50
      },
    },
    'city': {
      presence: { allowEmpty: false, message: 'is required', admin: 'optional', label: 'City' },
      email: false,
      length: {
          minimum: 2,
        maximum: 20
      },

    },
    'state': {
      presence: { allowEmpty: false, message: 'is required', admin: 'optional', label: 'State' },
      email: false,
      length: {
          minimum: 2,
        maximum: 20
      },
    },
    'country': {
      presence: { allowEmpty: false, message: 'is required', admin: 'optional', label: 'Country' },
      email: false,
      length: {
          minimum: 2,
        maximum: 20
      },
    },
    'postalCode': {
      presence: { allowEmpty: false, message: 'is required', admin: 'optional', label: 'ZIP/Postal Code' },
      email: false,
      length: {
          minimum: 4,
        maximum: 25
      },
    },
    phone: {
      presence: { allowEmpty: false, message: 'is required', admin: 'optional', label: 'Phone*' },
      email: false,
      length: {
          minimum: 10,
        maximum: 20
      },
    },
    password: {
      presence: { allowEmpty: false, message: 'is required', admin: 'required', label: 'Password*' },
      length: {
          minimum: 8,
          message: "must be at least 8 characters",
        maximum: 20
      },
    },
    policy: {
      presence: { allowEmpty: false, message: 'is required', admin: 'hidden', label: 'Repeat Password*' },
      checked: true,
    },

    role: {
        presence: {
            allowEmpty: false, message: 'is required', admin: 'required', label: 'Role*', select: [
                {label: 'User', value: 'user'},
                {label: 'Admin (View Only)', value: 'admin-orgViewer'},
                {label: 'Admin (Full Access)', value: 'admin-org'},
            ]
        },
        email: false,
        length: {
            minimum: 2,
            message: "Must select a user role",
          maximum: 20
        },
    },
    memberGroup: {
        presence: {
            allowEmpty: true, message: 'not required', admin: 'optional', label: 'Group', select: [
                {value: 'Narrasys'},
                //{value: 'Department of Agriculture, Colorado'},
                {value: 'Soil Health Academy'},
                {value: 'General Mills'},
                {value: 'Kiss The Ground'},
                {value: 'Understanding Ag'},
                {value: 'KDHE'},
                //{value: 'Michigan State University'}
            ]
        },
        email: false,
    },
    subscribed: {
        presence: { allowEmpty: true, message: 'not required', admin: 'optional' , label: 'Subscribed (optional)', select: []},
        checked: true,
        
      },
  };

  export default schema;